export default __webpack_public_path__ + "static/media/karavan_2.fb313ef8.png";